import React from "react";
import SnackBar from "../../../components/SnackBarComponent/SnackBar.component";

const Snackbar = (props) => {
  return <SnackBar {...props} />;
};

export default Snackbar;
